module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門5_4.09d9da10.png";